import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import useSchemas from "../hooks/useSchemas"

function SEO({
  description,
  lang,
  meta,
  title,
  pathname,
  robots,
  preload,
  youtubeSchemas = [],
  schemaData
}) {
  const wdw = typeof window !== "undefined" && window

  useEffect(() => {
    const query = wdw.location.search

    if (query) {
      sessionStorage.setItem("params", query)
    }
  }, [])

  // useEffect(() => {
  //   const sessionParams = sessionStorage.getItem("params")

  //   if (sessionParams) {
  //     history.replaceState({}, null, sessionParams)
  //   }
  // }, [])

  const { site, schema, social } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            fullPracticeName
          }
        }
        schema: allDataJson(filter: { schemaGeneral: { ne: null } }) {
          nodes {
            schemaGeneral
          }
        }
        social: allDataJson(filter: { optionsItem: { eq: "siteVariables" } }) {
          nodes {
            socialImage
          }
        }
      }
    `
  )

  const { schemas } = useSchemas(schemaData)
  const combinedSchemas = schemas.concat(youtubeSchemas)

  let schemaJson = JSON.stringify(
    {
      "@context": {
        "@vocab": "https://schema.org/"
      },
      "@graph": combinedSchemas
    },
    null,
    2
  )

  const socialImage = social.nodes[0].socialImage

  const metaRobots = robots

  const metaDescription = description || site.siteMetadata.description

  const siteUrl = site.siteMetadata.siteUrl

  const practiceName = site.siteMetadata.fullPracticeName

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          property: `og:image`,
          content: socialImage
        },
        {
          property: `og:image:width`,
          content: `1200`
        },
        {
          property: `og:image:height`,
          content: `627`
        },
        {
          property: `og:image:alt`,
          content: practiceName
        },
        {
          property: `og:url`,
          content: `${siteUrl}${pathname || "/"}`
        },
        {
          name: `robots`,
          content: metaRobots
        }
      ].concat(meta)}>
      {preload &&
        preload.map(item => (
          <link key={item.href} rel="preload" as={item.as} href={item.href} />
        ))}

      {combinedSchemas.length > 0 && (
        <script type="application/ld+json">{schemaJson}</script>
      )}

      <script
        type="text/javascript"
        src="data:text/javascript;base64,LyogQWxsaSBBSSB3aWRnZXQgZm9yIHN5bXBob255ZGVudGFsc2YuY29tICovCihmdW5jdGlvbiAodyxkLHMsbyxmLGpzLGZqcykge3dbJ0FsbGlKU1dpZGdldCddPW87d1tvXSA9IHdbb10gfHwgZnVuY3Rpb24gKCkgeyAod1tvXS5xID0gd1tvXS5xIHx8IFtdKS5wdXNoKGFyZ3VtZW50cykgfTtqcyA9IGQuY3JlYXRlRWxlbWVudChzKSwgZmpzID0gZC5nZXRFbGVtZW50c0J5VGFnTmFtZShzKVswXTtqcy5pZCA9IG87IGpzLnNyYyA9IGY7IGpzLmFzeW5jID0gMTsgZmpzLnBhcmVudE5vZGUuaW5zZXJ0QmVmb3JlKGpzLCBmanMpO30od2luZG93LCBkb2N1bWVudCwgJ3NjcmlwdCcsICdhbGxpJywgJ2h0dHBzOi8vc3RhdGljLmFsbGlhaS5jb20vd2lkZ2V0L3YxLmpzJykpO2FsbGkoJ2luaXQnLCAnc2l0ZV9zcWJ3cFB1QVdwa3Z5QldUJyk7YWxsaSgnb3B0aW1pemUnLCAnYWxsJyk7"></script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default SEO
